import Auth from "./Auth";
import Values from "./Values";
import Management from "./Management";
import Search from "./Search";
import Themes from "./Themes";
import ApplicationsStore from "./Applications";

export default {
  auth: new Auth(),
  values: new Values(),
  management: new Management(),
  search: new Search(),
  themes: new Themes(),
  applicationsStore: new ApplicationsStore()
};
